import { H as Z, z as G, _ as W, bt as S, Ze as g, u as y, b, Ye as u } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { d as V } from "./table-cell-DSuHhZzg-B8LqvfL6.js";
import { u as B } from "./class-map-DVI1Gii9-DxIsh-8w.js";
import { t as M } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
import { y as R } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c.js";
import { N as q } from "./query-assigned-K46zQIzj-dGW7AjV_.js";
function P(o, e) {
  if (o) {
    if (e && e.includes(o.localName))
      return o.id;
    if (o.parentElement)
      return o.parentElement.id;
  }
  return "";
}
const F = "headers";
function j(o, e, t, r, a, n, i) {
  var d, p, A, N, C;
  const D = e ? (C = (N = (A = o == null ? void 0 : o.parentElement) == null ? void 0 : A.parentElement) == null ? void 0 : N.nextElementSibling) == null ? void 0 : C.children : (p = (d = o == null ? void 0 : o.parentElement) == null ? void 0 : d.nextElementSibling) == null ? void 0 : p.children, H = P(o, r);
  let v;
  if (D && H) {
    const w = Array.from(D);
    if (w && w.length && (v = w.filter((f) => {
      const I = f.getAttribute(F);
      let z;
      return f && I && I === H && (t && a && a(f), z = f), z;
    })), v)
      return i && i(v, o), n && n(v, o), v;
  }
}
var c = /* @__PURE__ */ ((o) => (o.ASCENDING = "ascending", o.DESCENDING = "descending", o))(c || {}), O = /* @__PURE__ */ ((o) => (o.NORMAL = "normal", o.GROUP = "group", o.JUMBO = "jumbo", o))(O || {});
const U = Z`:host{--cell-wrapper-padding-inline-end: 0;--text-cell-padding-inline-start: var(--beacon-table-header-nth-cell-space-padding-inline-start);--text-cell-gap: 7px;font:inherit;inline-size:inherit;overflow:inherit;text-align:inherit;text-transform:inherit;word-break:initial}.hide{display:none}.table-header-wrapper{display:flex;inline-size:var(--table-override-header-wrapper-inline-size, inherit);padding-inline-end:var(--cell-wrapper-padding-inline-end)}.table-header-wrapper .text-cell{display:flex;gap:var(--text-cell-gap);inline-size:100%}.table-header-wrapper .text-cell__text{--text-cell-padding-block-start: var(--beacon-table-header-nth-cell-space-padding-block-start-normal);inline-size:inherit;padding-block-start:var(--text-cell-padding-block-start);padding-inline-start:var(--text-cell-padding-inline-start)}.table-header-wrapper .text-cell__text .title{margin:0}.table-header-wrapper .text-cell__text .subtitle{font-weight:var(--beacon-font-weight-normal);margin:0;text-transform:none}.table-header-wrapper .sort-icon{--override-icon-button-surface-size: var(--beacon-table-header-icon-size-normal);--sort-icon-padding-block-start: var(--beacon-table-header-sort-wrapper-space-padding-block-start-normal);display:var(--table-override-header-sort-icon-display, initial);padding-block-start:var(--sort-icon-padding-block-start)}.table-header-wrapper ::slotted([slot=action-zone]){--override-icon-button-surface-size: var(--beacon-table-header-icon-size-normal);--action-zone-padding-block-start: var(--beacon-table-header-action-zone-space-padding-block-start-normal);padding-block-start:var(--action-zone-padding-block-start)}.table-header-wrapper select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-origin:content-box;background-position:right center;background-repeat:no-repeat;border:0;cursor:inherit;inline-size:100%;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:break-spaces;word-break:break-word}.table-header-wrapper select:hover{text-decoration:underline}.table-header-wrapper select option{color:var(--beacon-colors-dark-grey-3)}.table-header-wrapper .selected-value{position:absolute;text-transform:initial;visibility:hidden;white-space:nowrap}.table-header-wrapper.jumbo .title,.table-header-wrapper.jumbo .subtitle,.table-header-wrapper.jumbo select,.table-header-wrapper.jumbo .selected-value{font-size:var(--beacon-body-font-size-100);line-height:var(--beacon-body-font-line-height-module-100);text-transform:initial}.table-header-wrapper.jumbo .text-cell__text{--text-cell-padding-block-start: var(--beacon-table-header-nth-cell-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo .sort-icon{--override-icon-button-surface-size: var(--beacon-table-header-icon-size-jumbo);--sort-icon-padding-block-start: var(--beacon-table-header-sort-wrapper-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo ::slotted([slot=action-zone]){--override-icon-button-surface-size: var(--beacon-table-header-icon-size-jumbo);--action-zone-padding-block-start: var(--beacon-table-header-action-zone-space-padding-block-start-jumbo)}.table-header-wrapper .table-dropdown{--dropdown-padding-block-start: var(--beacon-table-header-dropdown-space-padding-block-start-normal);background-color:transparent;background-image:var(--beacon-table-header-icon-color-background);color:var(--beacon-color-hyperlink-default);cursor:pointer;display:var(--table-override-header-dropdown-display, flex);padding-block-start:var(--dropdown-padding-block-start)}.table-header-wrapper.jumbo .table-dropdown{--dropdown-padding-block-start: var(--beacon-table-header-dropdown-space-padding-block-start-jumbo)}`;
var J = Object.defineProperty, Y = Object.getOwnPropertyDescriptor, s = (o, e, t, r) => {
  for (var a = r > 1 ? void 0 : r ? Y(e, t) : e, n = o.length - 1, i; n >= 0; n--)
    (i = o[n]) && (a = (r ? i(e, t, a) : i(a)) || a);
  return r && a && J(e, t, a), a;
};
const $ = "beacon-table-header", K = ["beacon-icon-button"], T = "aria-sort", Q = ".beacon-table", X = ".cell", ee = "has-dropdown", te = "headers", L = "display: none", h = "beacon-icon-button", m = "number-of-headers", x = "selected", re = ".selected-value", _ = "sorted", ae = "sort-direction", oe = "sort-inactive", k = "style", E = class extends M(V) {
  constructor() {
    super(...arguments), this.subtitle = "", this.variant = O.NORMAL, this.dropdown = !1, this.sortable = !1, this.hasActionZone = !1, this.sortInactive = !1, this.selectedValue = "select", this.selectedWidth = 0, this.nestedHeaders = [], this.beaconTagName = $, this.compare = (e, t) => this.sortDirection === c.ASCENDING ? e.value === t.value ? 0 : typeof e.value == "number" && typeof t.value == "number" ? e.value - t.value : e.value < t.value ? -1 : 1 : this.sortDirection === c.DESCENDING ? e.value === t.value ? 0 : typeof e.value == "number" && typeof t.value == "number" ? t.value - e.value : e.value > t.value ? -1 : 1 : 0, this.getParentElementHeaders = (e) => {
      let t = "";
      return e && e.parentElement && (t = e.parentElement.getAttribute(te) || ""), t;
    }, this.getSelectedFromElements = (e) => {
      let t;
      return e && e.length && (t = (e == null ? void 0 : e.find((r) => r.hasAttribute(x))) || e[0]), t;
    }, this.processNestedHeaders = (e) => {
      var t, r;
      if (e) {
        const a = (r = (t = this.parentElement) == null ? void 0 : t.parentElement) == null ? void 0 : r.children, n = a && Array.from(a);
        let i = 0;
        n && (i = this.findStartingIndex(n, e));
        for (const [d, p] of e.entries())
          p.id && this.nestedHeaders.push({
            value: p.id,
            selected: p.hasAttribute(x),
            colId: d + i
          });
        i && this.prepStyleObj(this.nestedHeaders);
      }
    }, this.prepStyleObj = (e) => {
      const t = document.querySelector(Q), r = t == null ? void 0 : t.querySelector(`${k}[${m}='${this.currentIndex}']`);
      r && (t == null || t.removeChild(r));
      const a = `{${L}}`;
      let n = "";
      for (const d of e)
        d.selected || (n = `${n + this.prepareStyleString(d.colId)},`);
      n = this.removeLastCharacter(n);
      const i = n + a;
      t && this.createStyleTag(t, i, this.currentIndex);
    }, this.createStyleTag = (e, t, r) => {
      if (e) {
        const a = document.createElement(k);
        a.innerText = `${t}`, a.setAttribute(m, r.toString()), e == null || e.appendChild(a);
      }
    }, this.setDropdownAttributes = (e) => {
      var t;
      e.setAttribute(k, L), (t = e.parentElement) == null || t.setAttribute(ee, "");
    }, this.siblingCollectionCallback = (e, t) => {
      t.subHeaderNodes = e.map((r) => r.querySelector(t.getScopedTagName($)));
    }, this.setSelectedAttributes = (e, t) => {
      const r = t.getSelectedFromElements(e);
      r == null || r.setAttribute(x, ""), t.processNestedHeaders(e);
    };
  }
  static get styles() {
    return [super.styles, U];
  }
  postrenderTableHeaderSetup() {
    var e;
    if (this.dropdown) {
      j(
        this,
        !0,
        !0,
        void 0,
        this.setDropdownAttributes,
        this.setSelectedAttributes,
        this.siblingCollectionCallback
      );
      const t = (e = this.nestedHeaders.find((r) => r.selected)) == null ? void 0 : e.value;
      this.selectedValue = t || this.selectedValue, this.adjustSelectWidth(), this.setColSpanForDropdowns();
      return;
    }
    j(this, !0, !1, void 0, void 0, void 0, this.siblingCollectionCallback);
  }
  /** Sets a data attribute on the parent element equal to the columns it would span if it wasn't using the dropdown feature. */
  setColSpanForDropdowns() {
    var e;
    this.parentElement && ((e = this.subHeaderNodes) == null ? void 0 : e.length) > 0 && (this.parentElement.dataset.colSpan = this.subHeaderNodes.length.toString());
  }
  /**
   * Process while on column sort happens.
   */
  onSort() {
    var e;
    if (this.sortable) {
      const t = ((e = this.parentElement) == null ? void 0 : e.id) || "", r = this.getParentElementHeaders(this);
      this.sortDirection === c.ASCENDING ? this.sortDirection = c.DESCENDING : this.sortDirection = c.ASCENDING, G(this, W.SORT, { detail: { id: t, headers: r } }), this.setSortedAttr();
    }
  }
  /**
   * Sets related ARIA_SORT attribute to the parentElement th. This being used when sort happens.
   */
  setSortedAttr() {
    var e, t;
    (e = this.parentElement) == null || e.setAttribute(T, this.sortDirection), (t = this.parentElement) == null || t.classList.add(_), this.sortInactive = !1;
  }
  /**
   * When Sorting happens on another columns this removes any sort attributes applied to parentElement th.
   * @param ele HTMLElement| Element
   */
  resetSortedAttr(e) {
    var t;
    e && (e.setAttribute(oe, "true"), e.removeAttribute(ae), e.removeAttribute(T), (t = e.parentElement) == null || t.classList.remove(_));
  }
  /**
   * Based on sortInactive returns token value.
   * @returns token value.
   */
  applySvgToken() {
    return this.sortInactive ? "var(--beacon-color-cta-text-tertiary-inactive)" : "var(--beacon-color-cta-text-tertiary-default)";
  }
  /**
   *
   * @returns TemplateResult
   */
  handleSortIcon() {
    let e;
    return this.sortable && (this.sortDirection === c.ASCENDING ? e = S`<${this.getScopedTag(h)}
          @beacon-event-click="${this.onSort}"
          id="${c.ASCENDING}"
          label="${c.ASCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(h)}>` : this.sortDirection === c.DESCENDING ? e = S`<${this.getScopedTag(h)}
          @beacon-event-click="${this.onSort}"
          id="${c.DESCENDING}"
          label="${c.DESCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
              style="fill: ${this.applySvgToken()}"
            />
          </svg>
        </${this.getScopedTag(h)}> ` : e = S`<${this.getScopedTag(h)}
          @beacon-event-click="${this.onSort}"
          id="sort"
          label="default-sorting"
          variant="tertiary"
          class="sort-icon"
        >
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(h)}>`), e || g``;
  }
  /**
   * Triggers when selection change happens to dropdown.
   * @param event
   */
  async handleSelectChange(e) {
    var t;
    this.selectedValue = (t = e.target) == null ? void 0 : t.value, this.resetSortedAttr(this), await this.updateComplete.then(() => (this.nestedHeaders = this.updateNestedHeaders(this.nestedHeaders, this.selectedValue), this.prepStyleObj(this.nestedHeaders), this.adjustSelectWidth()));
  }
  /**
   * It processes nestedHeaders based on provided array.
   * @param nestedHeaders TableHeaderDropdown[]
   * @param selectedValue string
   * @returns TableHeaderDropdown[]
   */
  updateNestedHeaders(e, t) {
    return e && e.forEach((r) => {
      r.selected ? r.selected = !1 : r.value === t && (r.selected = !0);
    }), e;
  }
  /**
   * While Dropdown is true, this will update correct spacing for the arrow icon and text.
   */
  async adjustSelectWidth() {
    var e, t, r;
    await this.updateComplete;
    const a = this.shadowRoot && ((e = this.shadowRoot) == null ? void 0 : e.querySelector(re)), n = this.shadowRoot && ((t = this.shadowRoot) == null ? void 0 : t.querySelector(X));
    if (a && n) {
      const i = (r = window.getComputedStyle(n)) == null ? void 0 : r.paddingLeft, d = i && parseInt(i, 10) || 0, p = a.offsetWidth;
      p < n.offsetWidth - d ? this.selectedWidth = p + 4 : this.selectedWidth = 0;
    }
  }
  /**
   * Pass collection of below elements to return from what could be the starting index for particular table-header.
   * @param parentElsArr Element[] - Collection of parentElement[]
   * @param currentEl Element[] - Collection of currentElement[]
   * @returns number
   */
  findStartingIndex(e, t) {
    this.setAttribute(m, t.length.toString()), this.currentIndex = e == null ? void 0 : e.findIndex((a) => a === this.parentElement);
    let r = 0;
    for (let a = 0; a < this.currentIndex; a += 1) {
      const n = e[a];
      if (n) {
        const i = n.firstElementChild;
        if (i && i.hasAttribute(m)) {
          const d = i.getAttribute(m);
          d && (r = parseInt(d, 10) + a);
        } else
          r = a + 1;
      }
    }
    return r;
  }
  /**
   * Provided string to be checked if it has any extra comma available at the end and it will remove it.
   * @param str string
   * @returns string
   */
  removeLastCharacter(e) {
    let t = "";
    return e && e.lastIndexOf(",") === e.length - 1 && (t = e.substring(0, e.length - 1)), t;
  }
  /**
   * Based on index will prepare string to hide column.
   * @param index number
   * @returns string
   */
  prepareStyleString(e) {
    return `td:nth-of-type(${e})`;
  }
  /**
   * Sets state variable dependent on slotted action-zone elements
   *
   * @param {Event} e
   */
  actionZoneSlotChange(e) {
    var t;
    this.hasActionZone = !!((t = this.slottedActionZone) != null && t.length);
  }
  /**
   * Action zone render method that conditionally hides padding based on `hasActionZone` state variable
   */
  renderActionZone() {
    const e = {
      "has-cell-padding": !0,
      "action-cell": !0,
      hide: !this.hasActionZone
    };
    return g`
      <div class=${B(e)}>
        <slot name="action-zone" @slotchange=${this.actionZoneSlotChange}></slot>
      </div>
    `;
  }
  render() {
    return g`<div class="table-header-wrapper ${this.variant}">
      <div class="has-cell-padding text-cell" part="text-cell">
        <div class="text-cell__text">
          <p class="title">
            <slot></slot>
          </p>
          <p class="subtitle"><slot name="subtitle">${this.subtitle}</slot></p>
          ${this.dropdown ? g`<select
                  id="select"
                  @change="${this.handleSelectChange}"
                  style="background-position: ${this.selectedWidth ? `${this.selectedWidth}px` : "left 100% top 50%"};
                width: ${this.selectedWidth ? "100%" : "calc(100% + 4px)"}"
                  name="dropdown"
                  class="table-dropdown"
                  value=${this.selectedValue}
                  aria-label="${this.selectedValue}"
                >
                  ${this.nestedHeaders ? this.nestedHeaders.map((e) => g`<option ?selected=${e.selected}>${e.value}</option>`) : y}
                </select>
                <span class="selected-value" aria-hidden="true">${this.selectedValue}</span>` : y}
        </div>
        ${this.sortable ? this.handleSortIcon() : y}
      </div>
      ${this.renderActionZone()}
    </div> `;
  }
};
E.tagName = $, E.nestedComponents = K;
let l = E;
s([
  b({ reflect: !0, alternateSlot: "subtitle", sync: !1 })
], l.prototype, "subtitle", 2);
s([
  b({ reflect: !0 })
], l.prototype, "variant", 2);
s([
  b({ attribute: "dropdown", type: Boolean, reflect: !0 })
], l.prototype, "dropdown", 2);
s([
  b({ attribute: "sortable", type: Boolean, reflect: !0 })
], l.prototype, "sortable", 2);
s([
  u()
], l.prototype, "hasActionZone", 2);
s([
  b({ attribute: "sort-direction", reflect: !0 })
], l.prototype, "sortDirection", 2);
s([
  b({ attribute: "sort-inactive", type: Boolean, reflect: !0 })
], l.prototype, "sortInactive", 2);
s([
  q({ flatten: !0, slot: "action-zone" })
], l.prototype, "slottedActionZone", 2);
s([
  u()
], l.prototype, "selectedValue", 2);
s([
  u()
], l.prototype, "selectedWidth", 2);
s([
  u()
], l.prototype, "subHeaderNodes", 2);
s([
  u()
], l.prototype, "nestedHeaders", 2);
s([
  u()
], l.prototype, "currentIndex", 2);
s([
  R
], l.prototype, "postrenderTableHeaderSetup", 1);
const he = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BeaconTableHeader: l
}, Symbol.toStringTag, { value: "Module" }));
export {
  j as H,
  he as index,
  l as s
};
